import dayjs from 'dayjs'
// import { STORAGE_NUM, LOAD_AND_UNLOAD_NUM, OPERATE_QUALITY } from '../../../constant/constant.js'
// import { companyAdvanceConfig, logicalWhAdvanceConfig } from '../../../constant/advanceConfig.js'

// 装卸
const loadUnloadSearchList = {
    searchTxt: [
        {
            name: '作业省份',
            value: 'provinceCode',
            type: 'slot',
            unfold: true,
            span: 8,
        },
        {
            name: '作业城市',
            value: 'cityCodeList',
            type: 'slot',
            unfold: true,
            span: 8,
        },
    ],
    unfoldState: false,
}
const loadUnloadTable = {
    pageId: 'idleResourceLoadUnloadMatchPageId250805',
    height: '384px',
    columns: [
        {
            label: '匹配度',
            prop: 'matchValue',
            width: '80px',
        },
        {
            label: '联系人',
            prop: 'contacts',
            width: '100px',
        },
        {
            label: '联系人电话',
            prop: 'contactNumber',
            width: '120px',
        },
        {
            label: '人数',
            prop: 'peopleNumber',
            width: '100px',
        },
        {
            label: '岗位',
            prop: 'postCode',
            type: 'select',
            optionNum: 'SRM_POST_TYPE',
            options: [],
            width: '100px',
        },
        {
            label: '作业省份',
            prop: 'provinceName',
            width: '130px',
        },
        {
            label: '作业城市',
            prop: 'cityName',
            width: '130px',
        },
        {
            label: '作业区县',
            prop: 'areaName',
            width: '130px',
        },
        {
            label: '计量单位',
            prop: 'measurementUnitCode',
            type: 'select',
            optionNum: 'IDLE_DEMAND_RESOURCES_METER_TYPE',
            options: [],
            width: '100px',
        },
        {
            label: '单价/元',
            prop: 'priceUnit',
            width: '100px',
        },
        {
            label: '说明备注',
            prop: 'remark',
            width: '150px',
        },
        {
            label: '开始日期',
            prop: 'startTime',
            width: '100px',
        },
        {
            label: '结束日期',
            prop: 'endTime',
            width: '100px',
        },
        {
            label: '状态',
            prop: 'state',
            type: 'select',
            optionNum: 'IDLE_DEMAND_RESOURCES_STAGE_TYPE',
            options: [],
            width: '100px',
        },
    ],
}

// 仓库
const warehouseSearchList = {
    searchTxt: [
        {
            name: '意向省份',
            value: 'provinceCode',
            type: 'slot',
            unfold: true,
            span: 8,
        },
        {
            name: '意向城市',
            value: 'cityCodeList',
            type: 'slot',
            unfold: true,
            span: 8,
        },
    ],
    unfoldState: false,
}
const warehouseTable = {
    pageId: 'idleResourceWarehouseMatchPageId250805',
    height: '384px',
    columns: [
        {
            label: '联系人',
            prop: 'contacts',
            width: '100px',
        },
        {
            label: '联系人电话',
            prop: 'contactNumber',
            width: '120px',
        },
        {
            label: '需求省份',
            prop: 'provinceName',
            width: '130px',
        },
        {
            label: '需求城市',
            prop: 'cityName',
            width: '130px',
        },
        {
            label: '需求区县',
            prop: 'areaName',
            width: '130px',
        },
        {
            label: '仓库类型',
            prop: 'warehouseType_',
            // type: 'select',
            // optionNum: 'SYS_SU_WH_TYPE',
            // options: [],
            width: '180px',
        },
        {
            label: '消防验收',
            prop: 'warehouseFireProtectionLevel',
            type: 'select',
            optionNum: 'SYS_SU_FIRE_INSPECTION',
            options: [],
            width: '120px',
        },
        {
            label: '需求客户',
            prop: 'demandCustomer',
            width: '100px',
        },
        {
            label: '需求面积/m²',
            prop: 'requiredArea',
            width: '100px',
        },
        {
            label: '租赁时长/月',
            prop: 'leaseDuration',
            width: '100px',
        },
        {
            label: '可接受最高单价',
            prop: 'highestUnitPrice',
            width: '120px',
        },
        {
            label: '启用日期',
            prop: 'activationDate',
            width: '100px',
        },
        {
            label: '其他特殊要求',
            prop: 'otherSpecialRequirements',
            width: '160px',
        },
        {
            label: '更新人',
            prop: 'updateUserName',
            width: '100px',
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            width: '150px',
        },
    ],
}

// 设备类
const deviceSearchList = {
    searchTxt: [
        // {
        //     name: '绩效单据编码',
        //     value: 'performanceCode',
        //     type: 'input',
        //     unfold: true,
        //     span: 3,
        // },
    ],
    unfoldState: false,
    advancedBtn: false,
}
const deviceTable = {
    pageId: 'idleResourceDeviceId250805',
    height: '384px',
    columns: [
        {
            label: '绩效单据编码',
            prop: 'performanceCode',
            width: '150px',
        },
        // {
        //     label: '仓库类型',
        //     prop: 'deviceType',
        //     type: 'select',
        //     optionNum: 'WH_CATEGORY',
        //     width: '100px',
        // },
        {
            label: '创建人',
            prop: 'createUserName',
            width: '100px',
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: '160px',
        },
        {
            label: '更新人',
            prop: 'updateUserName',
            width: '100px',
        },
    ],
}
    

export default {
    // configuration: true,
    // configurationModalAppendToBody: true,
    configurationAppendToBody: true,
    loadUnloadSearchList,
    warehouseSearchList,
    deviceSearchList,
    searchList: loadUnloadSearchList,
    loadUnloadTable,
    warehouseTable,
    deviceTable,
    table: loadUnloadTable,
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageSizes: [10, 20, 50],
    },
}
